import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from "@angular/core";
import { NgxSmartModalComponent, NgxSmartModalService } from "ngx-smart-modal";
import moment from "moment";
import { UI } from "../../../services/ui.service";
import {
  EReplaceShowStrategy,
  ShowRepository,
} from "../../../domain/show-repository";
import { MediaRepository } from "../../../domain/media-repository";
import { MediaInfo, MediaItem } from "../../../domain/media";
import { Show } from "../../../domain/show";

@Component({
  // tslint:disable-next-line:component-selector
  selector: "evrideo-replace-show-modal",
  templateUrl: "./replace-show-modal.component.html",
  styleUrls: ["./replace-show-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReplaceShowModalComponent implements AfterViewInit {
  constructor(
    private ngxSmartModalService: NgxSmartModalService,
    private changeDetectorRef: ChangeDetectorRef,
    private showRepository: ShowRepository,
    private ui: UI,
    private mediaRepository: MediaRepository,
  ) {}

  showToReplace: Show;
  mediaCustomId: string;
  applyToAllInstances: boolean;
  untilDate: moment.Moment;
  isProccesing = false;
  channelFramerate = 25;
  validateViewModel = true;
  viewModelState = EViewModelState.Default;
  replaceShowStrategy = EReplaceShowStrategy.Default;
  replaceMedia: MediaInfo;
  deltaBetweenShowAndMediaInMs: number;

  ngAfterViewInit() {
    this.ngxSmartModalService
      .getModal("replaceShowModal")
      .onDataAdded.subscribe(
        (data: { show: Show; channelFramerate: number }) => {
          this.viewModelState = EViewModelState.Default;
          this.showToReplace = data.show;
          this.mediaCustomId = "";
          this.applyToAllInstances = false;
          this.untilDate = null;
          this.channelFramerate = data.channelFramerate;
          this.validateViewModel = true;

          this.changeDetectorRef.markForCheck();
        },
      );
  }

  cancel() {
    this.ngxSmartModalService.getModal("replaceShowModal").close();
  }

  async replace() {
    console.log("strategy", this.replaceShowStrategy);
    if (this.validateViewModel) {
      await this.checkViewModelState();
      if (this.viewModelState === EViewModelState.MediaIdDoesNotExist) {
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Couldn't complete the operation",
          message: "Media id doesn't exist",
        });
        this.cancel();
      }
      this.changeDetectorRef.markForCheck();
      this.validateViewModel = false;

      if (this.viewModelState === EViewModelState.Default) {
        await this.replace();
      }
    } else {
      if (this.isProccesing) {
        return;
      }
      if (
        !this.mediaCustomId ||
        (this.applyToAllInstances && !this.untilDate)
      ) {
        return;
      }

      this.isProccesing = true;
      try {
        await this.showRepository.replaceShow(
          this.showToReplace.id,
          this.mediaCustomId,
          this.applyToAllInstances,
          this.replaceShowStrategy,
          this.untilDate,
        );

        this.ngxSmartModalService.getModal("replaceShowModal").close();
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Success",
          message: "Successfully replaced show",
        });

        this.isProccesing = false;
      } catch (error) {
        this.ngxSmartModalService.getModal("replaceShowModal").close();
        let errorMessage;
        if (error.status === 404) {
          errorMessage = "Media id doesn't exist";
        } else if (error.status === 400) {
          errorMessage = JSON.parse(error._body).Message;
        } else if (error.status === 412) {
          errorMessage = error.error;
        } else {
          errorMessage = "An error has occurred";
        }

        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Couldn't complete the operation",
          message: errorMessage,
        });
        this.isProccesing = false;
      }
    }
  }

  private async checkViewModelState() {
    const foundMediaId = await this.mediaRepository.getMediaIdByTenantUniqueId(
      this.mediaCustomId.trim(),
    );
    if (foundMediaId) {
      this.replaceMedia = await this.mediaRepository.getMediaInfo(foundMediaId);

      const deltaDuration = this.replaceMedia.contentDuration
        .subtract(this.showToReplace.duration)
        .asMilliseconds();
      this.deltaBetweenShowAndMediaInMs = Math.abs(deltaDuration);
      if (deltaDuration > 0) {
        this.viewModelState = EViewModelState.ItemIsLonger;
      } else if (deltaDuration === 0) {
        this.viewModelState = EViewModelState.Default;
      } else {
        this.viewModelState = EViewModelState.ItemIsShorter;
      }
    } else {
      this.viewModelState = EViewModelState.MediaIdDoesNotExist;
    }
  }
}

export enum EViewModelState {
  Default,
  MediaIdDoesNotExist,
  ItemIsLonger,
  ItemIsShorter,
}
